<!-- 
    TODO: Move cipo-layout in a separate component, with a separate route (tenant)
    The pages that tenant specific, should not be inside cipo-layout. This will ensure that the requests that are placed inside store's onInit wil not be called
    This is not possible right now, because ui-view needs to be initialized at startup, so this should be done after switching to Angular the entire app

    cipo class is added to separate angular styles from angularjs styles 
  -->
<div class="app-wrapper">
    <div class="main-app-content">
        @if (!userStore.isLoading()) {
            <cipo-smart-banner></cipo-smart-banner>
        }
        <cipo-layout [showHeader]="showHeader()">
            @if (userStore.isLoading()) {
                <cipo-loading [loading]="true" />
            }
            <div
                [ngClass]="
                    !userStore.isLoading() && !userStore.angularJsRoute()
                        ? 'cipo--height--full cipo--overflow--hidden cipo'
                        : 'cipo--display--none'
                ">
                <router-outlet></router-outlet>
            </div>
            <div
                [ngClass]="
                    !userStore.isLoading() && userStore.angularJsRoute() ? 'cipo--height--full' : 'cipo--display--none'
                ">
                <div ui-view id="index_view"></div>
            </div>
        </cipo-layout>
    </div>

    @if (aiStore.isOpen()) {
        @if (!userStore.isSmallScreen()) {
            <div class="cipo-ai-resizer" (mousedown)="startResize($event)"></div>
        }
        <div
            class="drawer-ai-sidebar cipo-bg--primary-50 cipo--height--full"
            [style.width.px]="userStore.isSmallScreen() ? null : aiStore.sidebarWidth()">
            <cipo-ai />
        </div>
    }

    <cipo-a11y-color-filter />
    <cipo-a11y-reading-aid />
</div>
